import { classifyStock, stockLevelLabel, type StockLevel } from '@/lib/inventoryStock'

type StockLevelBadgeProps = {
  stockQuantity: number
  threshold: number
}

const styles: Record<StockLevel, string> = {
  out: 'bg-destructive/15 text-destructive',
  low: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  ok: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
}

export function StockLevelBadge({ stockQuantity, threshold }: StockLevelBadgeProps) {
  const level = classifyStock(stockQuantity, threshold)
  if (level === 'ok') return null
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${styles[level]}`}
    >
      {stockLevelLabel(level)}
    </span>
  )
}
